import React from 'react';
import Section from '../Section';
import Offers from './Offers';

import image from './main-bg.jpg';

const text =`
  <p><strong>CustomArt</strong> to 12 lat doświadczenia scenicznego, ogromna sieć kontaktów, doskonała znajomość potrzeb zarówno agencji, klientów bezpośrednich jak i samych artystów oraz rozbudowana oferta usług dedykowanych dla branży eventowej.</p>`

const OfferSection = () => {
  return (
    <Section 
      title="Oferta" 
      background={image}
      isFirstSection
      subtitle={text}
    >
      <div className="section__container">
        <Offers />
      </div>
    </Section>
  )
};

export default OfferSection;



// WEBPACK FOOTER //
// ./src/components/OfferSection/index.js